<template>
  <v-alert :type="getAlertType(vigenciaCup)" dense :color="getAlertColor(vigenciaCup)">
    {{ getAlertText(vigenciaCup) }}
  </v-alert>
</template>
<script>
import moment from 'moment'

export default {
  props: {
    vigenciaCup: {
      type: String,
    },
  },

  methods: {
    getAlertType(fecha_vigencia_cup) {
      if (fecha_vigencia_cup !== '') {
        const meses = moment(fecha_vigencia_cup, this.API_DATE_FORMAT).diff(moment(), 'months', true)
        if (meses > 7) return 'success'
        if (meses <= 7 && meses >= 5) return 'warning'
        if (meses < 5) return 'error'
      }
      return 'info'
    },
    getAlertColor(fecha_vigencia_cup) {
      if (fecha_vigencia_cup !== '') {
        const meses = moment(fecha_vigencia_cup, this.API_DATE_FORMAT).diff(moment(), 'months', true)
        if (meses > 7) return 'green'
        if (meses <= 7 && meses >= 5) return 'yellow darken-2'
        if (meses < 5) return 'rgb(176, 0, 32)'
      }
      return 'blue-grey'
    },
    getAlertText(fecha_vigencia_cup) {
      if (fecha_vigencia_cup !== '') {
        return 'CUP: ' + this.getDateText(fecha_vigencia_cup)
      } else return 'CUP: Fecha no registrada'
    },
    getDateText(fecha) {
      return moment(fecha, this.API_DATE_FORMAT).format('DD/MM/YYYY')
    },
  },
  data() {
    return {
      API_DATE_FORMAT: 'YYYY-MM-DD',
    }
  },
}
</script>
